(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeOtherDetails(root, opened) {
      root.querySelectorAll('details').forEach(function (d) {
        if (d !== opened && d.open) {
          d.removeAttribute('open');
        }
      });
    }

    function initFaqExclusive(root) {
      if (!root || root.dataset.faqExclusiveInit === 'true') return;
      root.dataset.faqExclusiveInit = 'true';

      root.addEventListener(
        'toggle',
        function (event) {
          var t = event.target;
          if (!(t instanceof HTMLDetailsElement)) return;
          if (!root.contains(t)) return;
          if (t.open) {
            closeOtherDetails(root, t);
          }
        },
        false
      );
    }

    document.querySelectorAll('[data-faq-exclusive-accordion]').forEach(initFaqExclusive);

    if (!window.__faqAccordionSectionLoadBound) {
      window.__faqAccordionSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll('[data-faq-exclusive-accordion]').forEach(initFaqExclusive);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabbedContent(container) {
      if (container.dataset.tabbedInit === 'true') return;
      var idPrefix = container.dataset.tabInstance;
      if (!idPrefix) return;

      container.dataset.tabbedInit = 'true';

      var buttons = container.querySelectorAll('.tabbed-content__tab-btn');
      var panels = container.querySelectorAll('.tabbed-content__panel');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = btn.dataset.tabIndex;

          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', 'true');
          });

          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          var targetPanel = container.querySelector(
            '[id="tab-panel-' + idPrefix + '-' + index + '"]'
          );
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.removeAttribute('hidden');
          }
        });
      });
    }

    document.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);

    if (!window.__tabbedContentSectionLoadBound) {
      window.__tabbedContentSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        event.target.querySelectorAll('[data-tabbed-content]').forEach(initTabbedContent);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-nav-horizon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var outsideBound = false;
    var cartUpdateBound = false;

    function pluralizeItem(count) {
      return count === 1 ? 'item' : 'items';
    }

    // Keep the utility nav cart count in sync with AJAX add-to-cart/cart updates.
    // The theme dispatches ThemeEvents.cartUpdate ('cart:update') with the fresh
    // cart object on event.detail.resource whenever the cart changes without a
    // full page reload (see assets/cart-icon.js for the equivalent header-cart
    // component). This section renders its own cart link/count markup instead of
    // <cart-icon>, so it needs its own listener to stay live.
    function bindUtilityNavCartUpdates() {
      if (cartUpdateBound) return;
      cartUpdateBound = true;

      document.addEventListener('cart:update', function (event) {
        var itemCount = event.detail && event.detail.resource && event.detail.resource.item_count;
        if (typeof itemCount !== 'number' || Number.isNaN(itemCount)) return;

        document.querySelectorAll('[data-utility-nav-cart-link]').forEach(function (link) {
          link.setAttribute('aria-label', 'Cart, ' + itemCount + ' ' + pluralizeItem(itemCount));
        });

        document.querySelectorAll('[data-utility-nav-cart-count]').forEach(function (countEl) {
          countEl.textContent = '(' + itemCount + ')';
        });
      });
    }

    function bindUtilityNavDropdowns() {
      document.querySelectorAll('.utility-nav__dropdown-trigger:not([data-nav-dropdown-bound])').forEach(function (trigger) {
        trigger.setAttribute('data-nav-dropdown-bound', 'true');

        var menuId = trigger.getAttribute('aria-controls');
        var menu = menuId ? document.getElementById(menuId) : null;
        if (!menu) return;

        function open() {
          trigger.setAttribute('aria-expanded', 'true');
          menu.removeAttribute('hidden');
        }

        function close() {
          trigger.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        }

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            close();
          } else {
            open();
          }
        });

        menu.addEventListener('keydown', function (e) {
          var items = Array.from(menu.querySelectorAll('.utility-nav__dropdown-item'));
          if (items.length === 0) return;
          var idx = items.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            items[(idx + 1) % items.length].focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            items[(idx - 1 + items.length) % items.length].focus();
          }
        });
      });

      if (!outsideBound) {
        outsideBound = true;
        document.addEventListener(
          'click',
          function (e) {
            document.querySelectorAll('.utility-nav__item--dropdown').forEach(function (item) {
              var t = item.querySelector('.utility-nav__dropdown-trigger');
              var m = item.querySelector('.utility-nav__dropdown');
              if (!t || !m) return;
              if (item.contains(e.target)) return;
              t.setAttribute('aria-expanded', 'false');
              m.setAttribute('hidden', '');
            });
          },
          true
        );

        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          document.querySelectorAll('.utility-nav__dropdown-trigger[aria-expanded="true"]').forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
            var id = t.getAttribute('aria-controls');
            var m = id ? document.getElementById(id) : null;
            if (m) m.setAttribute('hidden', '');
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindUtilityNavDropdowns);
    } else {
      bindUtilityNavDropdowns();
    }

    document.addEventListener('shopify:section:load', bindUtilityNavDropdowns);

    // Cart-update listener only needs to be attached once; it's not tied to any
    // particular render of the section markup like the dropdown bindings are.
    bindUtilityNavCartUpdates();
  })();

  } catch(e) { console.error(e); }
})();
})();
